import networkConf from '@/config/networks.json'

export const getNetworkDef = (netID, type) => {
  return networkConf.networks.find(network => {
    return network.netID === netID && network.type === type;
  });
};
 